import { render, staticRenderFns } from "./profit_return_list.vue?vue&type=template&id=8c6001e2"
import script from "./profit_return_list.vue?vue&type=script&lang=js"
export * from "./profit_return_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports